export default {
    intro: 'Look at clues like consonant hints, definitions, and example sentences<br />to figure out the word!',
    word: 'Word',
    meaning: 'Meaning',
    example: 'Example',
    resources: 'Resources',
    teacherFooter: {
        left: 'Please select a word from the questions on the left.',
    },
    emptyExample: 'No example sentences available.',
    openExample: 'Revealing an example sentence will reveal the entire word.',
    introSelectWord: 'Please select a word on the left to start!',
    subExamplesExpand: 'View more example sentences',
    subExamplesCollapse: 'Collapse',
    showInitial: 'Show initial letters',
    showAll: 'Show full word',
    show: 'Show',
    table: {
        question: 'Question',
        emptyMessage: 'No content available.',
    },
    teacher: {
        modal: {
            clearConfirm: {
                title: 'Clear all pending words?',
                message: 'All pending words will be removed. Continue?',
            },
            closeConfirm: {
                title: 'Discard your input?',
                message: 'Closing will discard all words in the pending list. Continue?',
            },
            questionDelete: {
                title: 'Delete this question?',
                // {word}: the headword of the question to be deleted. Warns that it will be permanently removed from the activity.
                message: "The question '{word}' will be removed from the activity. Continue?",
            },
            waitItemDelete: {
                title: 'Remove pending word?',
                // {word}: the pending word to be removed. Only removed from the queue; activity is not affected.
                message: "Remove '{word}' from the pending list. Continue?",
            },
            // {count}: number of words skipped due to duplicate dictionary entry
            duplicateNotice: '{count} word(s) already registered were not added.',
            // {count}: number of words skipped because they have no meaning
            skippedNotice: '{count} word(s) without meanings were not added.',
            // Confirmation when mixing empty-meaning words with valid ones
            mixedEmptyConfirm: {
                title: 'Register?',
                line1: '{empty} word(s) without meanings will not be added.',
                line2: 'Register only the remaining {valid} word(s)?',
            },
            // Notice when only empty-meaning words remain
            onlyEmptyNotice: {
                title: 'Cannot register',
                message: 'There are no words to register. Only words without meanings remain.',
            },
            registerFailed: 'Failed to add.',
        },
    },
};
